import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTE_DEFINITIONS } from '@/routes';
import { usePagePermissions } from '@/hooks/authorization/usePagePermissions';


interface ProtectedByPermissionProps {
  /** Route code to check. If omitted, auto-resolves from current URL. */
  screenCode?: string;
  children: React.ReactNode;
}

/**
 * Route-level guard that redirects to home if the user cannot view the screen.
 *
 * @example
 * // In App.tsx or wrapping a page component
 * <ProtectedByPermission>
 *   <EmployeeCreate />
 * </ProtectedByPermission>
 */
export const ProtectedByPermission: React.FC<ProtectedByPermissionProps> = ({
  screenCode,
  children,
}) => {
  const { canView, isLoaded } = usePagePermissions(screenCode);

  // Wait for permissions to load before making a decision
  if (!isLoaded) return null;

  if (!canView) {
    return <Navigate to={ROUTE_DEFINITIONS.ACCESO_DENEGADO.path} replace />;
  }

  return <>{children}</>;
};
